import React from 'react';
import { CheckCircle } from 'lucide-react';
export function AboutSection() {
  const values = ['Client-First Approach', 'Regulatory Compliance', 'Transparency in Operations', 'Ethical Business Practices', 'Data Security & Privacy', 'Continuous Improvement'];
  return <section id="about" className="py-16 bg-gray-50" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-14">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center" data-id="element-15">
          <div data-id="element-16">
            <h2 className="text-3xl font-bold text-gray-900 mb-6" data-id="element-17">
              About Max Cap Securities
            </h2>
            <p className="text-gray-600 mb-6" data-id="element-18">
              Max Cap Securities is an authorized sub-broker of TradeJini,
              committed to providing exceptional financial services to our
              clients. With years of experience in the Indian financial markets,
              we have established ourselves as a trusted partner for investors
              seeking reliable investment solutions.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-19">
              Our team of experienced professionals is dedicated to helping you
              navigate the complexities of the financial markets and achieve
              your investment goals. We combine industry expertise with
              personalized service to deliver value to our clients.
            </p>
            <p className="text-gray-600 mb-6" data-id="element-20">
              As a SEBI-registered sub-broker, we adhere to the highest
              standards of regulatory compliance and ethical business practices.
              Our clients' interests are always our top priority, and we strive
              to build long-term relationships based on trust and mutual
              success.
            </p>
          </div>
          <div className="bg-white p-8 rounded-lg shadow-sm" data-id="element-21">
            <h3 className="text-xl font-semibold text-gray-900 mb-6" data-id="element-22">
              Our Core Values
            </h3>
            <ul className="space-y-4" data-id="element-23">
              {values.map((value, index) => <li key={index} className="flex items-start" data-id="element-24">
                  <CheckCircle className="h-6 w-6 text-green-500 mr-2 flex-shrink-0" data-id="element-25" />
                  <span className="text-gray-600" data-id="element-26">{value}</span>
                </li>)}
            </ul>
            <div className="mt-8 pt-6 border-t border-gray-200" data-id="element-27">
              <h4 className="font-semibold text-gray-900 mb-2" data-id="element-28">
                Our Association
              </h4>
              <p className="text-gray-600" data-id="element-29">
                Authorized sub-broker of TradeJini, a SEBI-registered stock
                broker with membership in NSE, BSE, and MCX.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>;
}